import type { StatsTimelineSelectionTargets } from "#build-stats-timeline-selection-targets";

/** Nearest-date selection in O(log n), preserving the original scan's first-input tie break. */
export function findNearestStatsTimelineTimestamp(
  { fallbackTimestamp, positions }: StatsTimelineSelectionTargets,
  x: number,
): number | null {
  "worklet";
  if (!Number.isFinite(x) || positions.length === 0) {
    return fallbackTimestamp;
  }
  let low = 0;
  let high = positions.length;
  while (low < high) {
    const middle = Math.floor((low + high) / 2);
    if ((positions[middle]?.x ?? Number.POSITIVE_INFINITY) < x) {
      low = middle + 1;
    } else {
      high = middle;
    }
  }
  const before = positions[low - 1];
  const after = positions[low];
  const beforeDistance = before === undefined ? Number.POSITIVE_INFINITY : Math.abs(before.x - x);
  const afterDistance = after === undefined ? Number.POSITIVE_INFINITY : Math.abs(after.x - x);
  if (beforeDistance === Number.POSITIVE_INFINITY && afterDistance === Number.POSITIVE_INFINITY) {
    return fallbackTimestamp;
  }
  if (before === undefined) {
    return after?.timestamp ?? fallbackTimestamp;
  }
  if (after === undefined) {
    return before.timestamp;
  }
  return beforeDistance < afterDistance ||
    (beforeDistance === afterDistance && before.originalIndex < after.originalIndex)
    ? before.timestamp
    : after.timestamp;
}
